import React from 'react';

const ROLES = [
  { value: 'all', label: 'Todos los roles' },
  { value: 'cuidadora', label: 'Cuidadoras' },
  { value: 'trabajadora', label: 'Trabajadoras' },
];

const RoleFilter = ({ selectedRole, onChange }) => (
  <div className="manual-filter manual-filter--roles" role="group" aria-label="Filtrar por rol">
    {ROLES.map((role) => (
      <button
        key={role.value}
        type="button"
        className={`manual-filter__chip${selectedRole === role.value ? ' manual-filter__chip--active' : ''}`}
        onClick={() => onChange(role.value)}
      >
        {role.label}
      </button>
    ))}
  </div>
);

export default RoleFilter;

